<template>
  <div class='content-empty'>
   <div class='empty-pic'  v-if="cmptList">
     <img :src='common.ossAddr("/img/content-empty.png")' >
   </div>
   <span class="blank-content"  v-if="cmptList">{{$t('dc_lang.暂无内容')}}~</span>
    <div class='empty-pic'  v-if="competitor">
      <img :src='common.ossAddr("/img/content-empty.png")' >
    </div>
    <span class="blank-content"  v-if="competitor">暂无参赛队员~</span>
    <div class='empty-pic'  v-if="team">
      <img :src='common.ossAddr("/img/content-empty.png")' >
    </div>
    <span class="blank-content"  v-if="team">暂无参赛队伍~</span>
   <div class='empty-pic' v-if="ranking">
     <img :src='common.ossAddr("/img/ranking-empty.png")' >
   </div>
   <span class="blank-content" v-if="ranking">暂无排行榜信息~</span>
  </div>
</template>

<script>
export default {
  name: 'empty-content',
  props: {
    cmptList: {
      type: Boolean
    },
    ranking: {
      type: Boolean
    },
    competitor: {
      type: Boolean
    },
    team: {
      type: Boolean
    }
  }
}
</script>

<style scoped>
  .content-empty{
    padding:20% 10% 35%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background-color: #ffffff;
  }
  .empty-pic{
    max-width: 100%;
  }
  .empty-pic img{
    max-width: 100%;
    margin: 0 auto;
  }
  .blank-content{
    font-size: 28px;/*px*/
    color: #BDC1C7;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/empty-content/empty-content.vue